import React from 'react';
import { useTranslation } from 'react-i18next';
import { capitalize, join } from 'lodash';

import { NavBackButton, ScrollableBox, SidebarHeader } from '@mssgme/ui';
import { useBilling, useNavigationUtils, useRestrictedCard } from '@mssgme/hooks';

import ListItem from './ListItem';
import { PageLayout } from '../../../UI';

import styles from './styles.scss';

export function PageSettingsMenu() {
    const { t } = useTranslation('cards');
    const { generateUrl } = useNavigationUtils();
    const restrictedCard = useRestrictedCard();
    const { isTrial } = useBilling();
    const {
        profile: { url },
        design: { branding },
        domain,
        analytics,
        seo,
    } = restrictedCard;
    const activeAnalyticsPlatforms = Object.entries(analytics)
        .filter((entry) => !!entry[1])
        .map((entry) => capitalize(entry[0]));
    const activeAnalyticsPlatformsPreview =
        activeAnalyticsPlatforms.length > 0 ? join(activeAnalyticsPlatforms, ', ') : t('PageSettingsMenu.values.empty');
    const seoPreview =
        seo.title || seo.description ? t('PageSettingsMenu.values.custom') : t('PageSettingsMenu.values.default');

    return (
        <PageLayout>
            <SidebarHeader
                heading={t('PageSettingsMenu.title')}
                leftButton={<NavBackButton to={generateUrl('..')} />}
            />
            <ScrollableBox className={styles.scrollBox}>
                <ul className={styles.list}>
                    <ListItem to={generateUrl('url')} name={t('PageSettingsMenu.labels.url')}>
                        <div className={styles.textPreview}>
                            {domain.name && domain.resolved ? domain.name : `mssg.me/${url}`}
                        </div>
                    </ListItem>
                    {!isTrial && (
                        <ListItem to={generateUrl('branding')} name={t('PageSettingsMenu.labels.branding')}>
                            <div className={styles.textPreview}>
                                {t(branding ? 'PageSettingsMenu.values.enabled' : 'PageSettingsMenu.values.disabled')}
                            </div>
                        </ListItem>
                    )}
                    <ListItem to={generateUrl('seo')} name={t('PageSettingsMenu.labels.seo')}>
                        <div className={styles.textPreview}>{seoPreview}</div>
                    </ListItem>
                    <ListItem to={generateUrl('tracking')} name={t('PageSettingsMenu.labels.tracking')}>
                        <div className={styles.textPreview}>{activeAnalyticsPlatformsPreview}</div>
                    </ListItem>
                </ul>
            </ScrollableBox>
        </PageLayout>
    );
}
